import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { emmitButtonClick } from 'depop/apps/root/components/HomeAB';
import { withRouter } from 'depop/contextWrappers';

import { trackDownLoadAppHeader } from 'depop/utils/tracking';

const theExperimentName = 'LandingPage_AB_mobile';

class DeepDownloadLink extends React.Component {
  props: {
    overlays: PropTypes.object,
    onclick: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {mounted: false};
  }

  componentDidMount() {
    this.setState({mounted: true});
  }

  clickDownloadApp = () => {
    const { overlays } = this.props;
    const { path: source } = overlays.deeplinkDownload || { path: '' };
    this.winExperiment();
    trackDownLoadAppHeader({ source });
  }

  winExperiment() {
    const { overlays } = this.props;
    const { landingAB } = overlays;

    if (!landingAB) {
      return () => false;
    }

    return emmitButtonClick(landingAB, 'download app');
  }

  render() {
    const { overlays, dispatch, userAgent, onclick, router, ...props } = this.props;
    const { mounted } = this.state;
    const { link } = overlays.deeplink || { link: '' };
    const isLanding = router.isActive('/', true);
    const channel = isLanding ? `landingpage_mobile_${userAgent.isAndroid ? 'google' : 'apple'}_a` : undefined;
    const href = (link) ? `${link}?channel=${channel || 'download%20button'}` : 'javascript:;';
    const onClick = onclick || this.clickDownloadApp;

    if (!mounted) {
      return null;
    }

    return <a
      target="_blank"
      href={href}
      onClick={onClick}
      {...props}>
      <FormattedMessage
        id="app.downloadLabel"
        description="Download Label"
        defaultMessage="Download App"
      />
    </a>;
  }
}

const mapStateToProps = ({ userAgent, overlays }) => ({
  userAgent,
  overlays,
});

export default connect(mapStateToProps)(withRouter(DeepDownloadLink));



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/DeepDownloadLink.js